/**
 * #654 -- the Create Payout dialog's default period.
 *
 * A payout covers commission that has already accrued, and the API refuses a
 * period that ends after today ("The payout period cannot end in the future").
 * The dialog used to default the end to the last day of the CURRENT month, so
 * its own default was refused on every day but the last. Default instead to the
 * start of this month through yesterday; on the 1st that would be empty, so use
 * the whole of last month (the last completed period).
 *
 * Dates are formatted from local parts: `toISOString()` is UTC and moves a
 * local-midnight date back a day east of Greenwich.
 */
function ymd(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

export function defaultPayoutRange(now: Date = new Date()): { start: string; end: string } {
  if (now.getDate() === 1) {
    return {
      start: ymd(new Date(now.getFullYear(), now.getMonth() - 1, 1)),
      end: ymd(new Date(now.getFullYear(), now.getMonth(), 0)),
    };
  }
  return {
    start: ymd(new Date(now.getFullYear(), now.getMonth(), 1)),
    end: ymd(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)),
  };
}
